import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@state-mgmt/store';

export const useGetProtocolName = () => {
  const { protocols } = useSelector((state: RootState) => state.protocol);
  return useCallback((protocolId: string): string | undefined => protocols.find(p => p.id === protocolId)?.name, [protocols]);
};
